/**
 * ALPR preservation demand and Article 39.14 request field coverage for one case.
 *
 * Read-only. These two letters only go out with a not-guilty letter. `applies` is false on every
 * other case, so the Documents tab can stay quiet on parking and deferral work.
 */

export interface MissingField {
  field: string;
  label: string;
}

export interface FieldCoverageReport {
  document: string;
  ready: boolean;
  missingRequired: MissingField[];
  blankOptional: MissingField[];
}

export interface AlprDocumentsReadinessDto {
  applies: boolean;
  preservationDemand: FieldCoverageReport;
  article3914Request: FieldCoverageReport;
}

export default class AlprDocumentsApi {
  private static host(): string {
    return process.env.API_HOST?.trim() || window.location.origin;
  }

  static async readiness(ticketGuid: string): Promise<AlprDocumentsReadinessDto> {
    const response = await fetch(
      `${AlprDocumentsApi.host()}/api/v1/manager/ticket/${ticketGuid}/alpr-documents/readiness`,
      { credentials: 'include' },
    );
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || err.message || 'Failed to check ALPR document readiness');
    }
    return response.json();
  }
}
